initArticleFavourites();

function initArticleFavourites() {
  const carousels = document.querySelectorAll("[data-article-favourites-swiper]");
  if (!carousels.length) return;
  if (!window.Swiper) return;

  const syncCarousel = (carousel) => {
    
    if (carousel.swiper) {
      carousel.swiper.update();
      return;
    }

    new window.Swiper(carousel, {
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 20,
      centeredSlides: true,
      speed: 500,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
          centeredSlides: false,
        },
      },
    });
  };

  carousels.forEach(syncCarousel);

  let resizeTimer;
  window.addEventListener("resize", () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      carousels.forEach(syncCarousel);
    }, 120);
  });
}
